import { ExternalLinkIcon } from "@radix-ui/react-icons";
import { Box, Button, Card, Flex, Text } from "@radix-ui/themes";
import { TEAM_PLAN_FORM_URL } from "../../consts";
import { useInterestForm } from "../../hooks/useInterestForm";
import { trackEvent } from "../../utils/posthogConfig";
import { CARD_STYLE } from "../dashboard/tokens";

/**
 * Fake door for a Team plan: measures demand and collects what teams need before we build it.
 * Shown only while the `team_plan_interest` dashboard flag is on.
 * The copy says plainly that team plans don't exist yet, so nobody clicks expecting to buy one.
 */
export default function TeamPlanRow() {
    const form = useInterestForm("teamPlanInterest", TEAM_PLAN_FORM_URL, "billing_page");
    if (!form) {
        return null;
    }

    return (
        <Card size="2" mt="4" style={CARD_STYLE}>
            <Flex align="center" justify="between" gap="4" wrap="wrap">
                <Box
                    style={{
                        flex: "1 1 280px",
                        minWidth: 0,
                    }}
                >
                    <Text as="div" size="2" weight="medium">
                        Buying for a team?
                    </Text>
                    <Text as="div" size="2" color="gray">
                        We're working on team plans, with several seats on one invoice. Tell us what your team needs.
                    </Text>
                </Box>
                <Button
                    asChild
                    variant="surface"
                    color="gray"
                    style={{
                        flex: "none",
                    }}
                >
                    <a
                        href={form.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() =>
                            void trackEvent("team_plan_interest_clicked", {
                                plan: form.plan,
                                surface: "billing_page",
                            })
                        }
                    >
                        Get in touch
                        <ExternalLinkIcon aria-hidden="true" />
                    </a>
                </Button>
            </Flex>
        </Card>
    );
}
